import {flatBoostersConfig} from "../config/flat_boosters";
import {flatInvestmentBoostersConfig} from "../config/flat_investment_boosters";
import {houseBoostersConfig} from "../config/house_boosters";
import {houseInvestmentBoostersConfig} from "../config/houses_investment_boosters";
import {modularHouseBoostersConfig} from "../config/modular_house_boosters";
import {IBoosterPropertyType} from "../types/IBoosterPropertyType";

export const getBoostersByPropertyType = (propertyType: IBoosterPropertyType) => {
    switch (propertyType) {
        case IBoosterPropertyType.Flat:
            return flatBoostersConfig;
        case IBoosterPropertyType.House:
            return houseBoostersConfig;
        case IBoosterPropertyType.ModularHouse:
            return modularHouseBoostersConfig;
        case IBoosterPropertyType.FlatInvestment:
            return flatInvestmentBoostersConfig;
        case IBoosterPropertyType.HouseInvestment:
            return houseInvestmentBoostersConfig;
        default:
            return null;
    }
};
import {flatBoostersConfig} from "../config/flat_boosters";
import {flatInvestmentBoostersConfig} from "../config/flat_investment_boosters";
import {houseBoostersConfig} from "../config/house_boosters";
import {houseInvestmentBoostersConfig} from "../config/houses_investment_boosters";
import {modularHouseBoostersConfig} from "../config/modular_house_boosters";
import {IBoosterPropertyType} from "../types/IBoosterPropertyType";

export const getBoostersByPropertyType = (propertyType: IBoosterPropertyType) => {
    switch (propertyType) {
        case IBoosterPropertyType.Flat:
            return flatBoostersConfig;
        case IBoosterPropertyType.House:
            return houseBoostersConfig;
        case IBoosterPropertyType.ModularHouse:
            return modularHouseBoostersConfig;
        case IBoosterPropertyType.FlatInvestment:
            return flatInvestmentBoostersConfig;
        case IBoosterPropertyType.HouseInvestment:
            return houseInvestmentBoostersConfig;
        default:
            return null;
    }
};
